import React from "react";

export const ResetFilterPrompt = ({
    onClick,
    prompt = "No results match your filter.",
    ...rest
}: {
    onClick: () => void;
    prompt?: string;
} & React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <div {...rest}>
            {prompt} Try&nbsp;
            <button className="link button-as-link" type="button" onClick={onClick}>
                resetting your filters.
            </button>
        </div>
    );
};

ResetFilterPrompt.displayName = "ResetFilterPrompt";
